import React from 'react'
import { ArrowCircleRightOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import FormDetailsStack from 'common/Form/FormDetailsStack'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'
import { format, formatDistance } from 'date-fns'

export default function OrderProgress(props: IOrderProgress) {
  const { createdAt, updatedAt } = props

  const createdAtDate = format(new Date(createdAt), 'dd MMM yyyy, HH:mm a')
  const sinceCreation = formatDistance(new Date(createdAt), new Date(), {
    addSuffix: true
  })
  const updatedAtDate = format(new Date(updatedAt), 'dd MMM yyyy, HH:mm a')

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        '& .MuiTypography-root': { margin: 0 }
      }}
    >
      <TextColorFontHeader>Order Progress</TextColorFontHeader>
      <Box>
        <FormDetailsStack
          formLabelHeader='Created at:'
          formContent={createdAtDate}
        />
      </Box>
      <Box>
        <FormDetailsStack
          formLabelHeader='Days since creation:'
          formContent={sinceCreation}
        />
      </Box>
      <Box>
        <FormDetailsStack
          formLabelHeader='Last managed at:'
          formContent={updatedAtDate}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          color: '#0000FF',
          cursor: 'pointer'
        }}
      >
        View Order Breakdown
        {/* TO REPLACE WITH THE CORRECT ICON */}
        <ArrowCircleRightOutlined />
      </Box>
    </Box>
  )
}

interface IOrderProgress {
  createdAt: string
  updatedAt: string
}
